import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "w-full px-6 py-8" }
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 items-stretch" }
const _hoisted_4 = { class: "service-card" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "service-card" }
const _hoisted_7 = { class: "service-card" }
const _hoisted_8 = { class: "space-y-4" }
const _hoisted_9 = { class: "text-sm text-black leading-relaxed" }
const _hoisted_10 = { class: "flex items-start gap-3 cursor-pointer" }

import { onMounted, ref } from 'vue'
import PageHeader from '@/components/layout/seller/PageHeader.vue'
import ConfirmModal from '@/components/common/ConfirmModal.vue'
import {
  acceptProductManagerCgu,
  getProductManagerCguStatus,
} from '@/api/productManagerCgu'
import { useNotification } from '@/composables/useNotification'

const PRODUCT_MANAGER_URL =
  'https://drive.google.com/drive/folders/1Buy87GG5DDZcEG6rE3D657nhavMrSYY_'

export default /*@__PURE__*/_defineComponent({
  __name: 'ServicesView',
  setup(__props) {

const cguUrl = `${process.env.BASE_URL}docs/cgu-product-manager.pdf`

const cguModalMessage = [
  'Cet outil vous permet de transférer vos fiches produits depuis une plateforme source vers votre compte Efashion.',
  '',
  "En utilisant cet outil, vous confirmez que vous êtes autorisé à utiliser et transférer les contenus concernés et demandez à Efashion d'effectuer les opérations techniques nécessaires à leur importation.",
].join('\n')

const { error: showError } = useNotification()

const showProductManagerCguModal = ref(false)
const productManagerCguAccepted = ref(false)
const hasAcceptedCurrentCgu = ref(false)
const isCheckingCgu = ref(false)
const isAcceptingCgu = ref(false)

const openProductManagerService = () => {
  window.open(PRODUCT_MANAGER_URL, '_blank', 'noopener,noreferrer')
}

const openProductManagerCguModal = () => {
  productManagerCguAccepted.value = false
  showProductManagerCguModal.value = true
}

const closeProductManagerCguModal = () => {
  showProductManagerCguModal.value = false
  productManagerCguAccepted.value = false
}

const loadCguStatus = async () => {
  isCheckingCgu.value = true
  try {
    const status = await getProductManagerCguStatus()
    hasAcceptedCurrentCgu.value = Boolean(status?.accepted)
  } catch {
    hasAcceptedCurrentCgu.value = false
  } finally {
    isCheckingCgu.value = false
  }
}

const handleProductManagerClick = async () => {
  if (isAcceptingCgu.value) return

  if (hasAcceptedCurrentCgu.value) {
    openProductManagerService()
    return
  }

  // Recharge au clic pour couvrir un changement de session / version
  isCheckingCgu.value = true
  try {
    const status = await getProductManagerCguStatus()
    hasAcceptedCurrentCgu.value = Boolean(status?.accepted)
    if (hasAcceptedCurrentCgu.value) {
      openProductManagerService()
      return
    }
  } catch {
    // Si le statut est indisponible, on affiche quand même la popup
  } finally {
    isCheckingCgu.value = false
  }

  openProductManagerCguModal()
}

const confirmProductManagerAccess = async () => {
  if (!productManagerCguAccepted.value || isAcceptingCgu.value) return

  isAcceptingCgu.value = true
  try {
    const status = await acceptProductManagerCgu()
    hasAcceptedCurrentCgu.value = Boolean(status?.accepted)
    closeProductManagerCguModal()
    openProductManagerService()
  } catch (err: unknown) {
    const message =
      err instanceof Error
        ? err.message
        : "Impossible d'enregistrer l'acceptation des CGU"
    showError(message)
  } finally {
    isAcceptingCgu.value = false
  }
}

onMounted(() => {
  void loadCguStatus()
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageHeader, {
      title: "Services",
      subtitle: "Découvrez nos services partenaires pour booster votre activité"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"service-card\" data-v-71a2c55a><div class=\"flex items-start justify-between mb-4\" data-v-71a2c55a><div class=\"w-12 h-12 rounded-xl bg-gradient-to-br from-indigo-500 to-purple-500 flex items-center justify-center text-white text-xl\" data-v-71a2c55a><i class=\"fas fa-camera\" data-v-71a2c55a></i></div><span class=\"text-xs font-semibold text-green-700 bg-green-100 px-2.5 py-1 rounded-full uppercase tracking-wide\" data-v-71a2c55a>Recommandé</span></div><h3 class=\"text-base font-semibold text-black mb-2\" data-v-71a2c55a>EasyAI - Photos IA</h3><p class=\"text-sm text-black leading-relaxed mb-4\" data-v-71a2c55a> Créez simultanément 10 photos IA en une dizaine de secondes. Générez des visuels professionnels pour vos produits grâce à l&#39;intelligence artificielle. </p><div class=\"space-y-2 mb-6 flex-1\" data-v-71a2c55a><div class=\"flex items-center gap-2 text-sm text-black\" data-v-71a2c55a><i class=\"fas fa-check-circle text-green-500\" data-v-71a2c55a></i><span data-v-71a2c55a>10 photos générées simultanément</span></div><div class=\"flex items-center gap-2 text-sm text-black\" data-v-71a2c55a><i class=\"fas fa-check-circle text-green-500\" data-v-71a2c55a></i><span data-v-71a2c55a>Résultat en quelques secondes</span></div><div class=\"flex items-center gap-2 text-sm text-black\" data-v-71a2c55a><i class=\"fas fa-check-circle text-green-500\" data-v-71a2c55a></i><span data-v-71a2c55a>Qualité professionnelle</span></div></div><a href=\"https://www.easyai.fr\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"mt-auto block w-full text-center px-6 py-2.5 bg-gradient-to-r from-indigo-500 to-purple-500 text-white rounded-lg hover:from-indigo-600 hover:to-purple-600 transition-all duration-300 text-sm font-semibold shadow-md hover:shadow-lg\" data-v-71a2c55a><i class=\"fas fa-external-link-alt mr-2\" data-v-71a2c55a></i> Accéder au service </a></div>", 1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"flex items-start justify-between mb-4\" data-v-71a2c55a><div class=\"w-12 h-12 rounded-xl bg-gradient-to-br from-blue-500 to-cyan-500 flex items-center justify-center text-white text-xl\" data-v-71a2c55a><i class=\"fas fa-box\" data-v-71a2c55a></i></div></div><h3 class=\"text-base font-semibold text-black mb-2\" data-v-71a2c55a>Product manager</h3><p class=\"text-sm text-black leading-relaxed mb-4 flex-1\" data-v-71a2c55a> Importez vos fiches produits et vos photos en quelques clics sur Efashion. </p>", 3)),
          _createElementVNode("button", {
            type: "button",
            class: "mt-auto block w-full text-center px-6 py-2.5 bg-gradient-to-r from-blue-500 to-cyan-500 text-white rounded-lg hover:from-blue-600 hover:to-cyan-600 transition-all duration-300 text-sm font-semibold shadow-md hover:shadow-lg disabled:opacity-60 disabled:cursor-wait",
            disabled: isCheckingCgu.value || isAcceptingCgu.value,
            onClick: handleProductManagerClick
          }, _cache[2] || (_cache[2] = [
            _createElementVNode("i", { class: "fas fa-external-link-alt mr-2" }, null, -1),
            _createTextVNode(" Accéder au service ")
          ]), 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"flex items-start justify-between mb-4\" data-v-71a2c55a><div class=\"w-12 h-12 rounded-xl bg-gradient-to-br from-orange-500 to-red-500 flex items-center justify-center text-white text-xl\" data-v-71a2c55a><i class=\"fas fa-sync-alt\" data-v-71a2c55a></i></div></div><h3 class=\"text-base font-semibold text-black mb-2\" data-v-71a2c55a> Import PrestaShop </h3><p class=\"text-sm text-black leading-relaxed mb-4 flex-1\" data-v-71a2c55a> Connectez votre boutique, complétez les fiches et importez votre catalogue sur eFashion. </p>", 3)),
          _createVNode(_component_router_link, {
            to: { name: 'services/prestashop' },
            class: "mt-auto block w-full text-center px-6 py-2.5 bg-gradient-to-r from-orange-500 to-red-500 text-white rounded-lg hover:from-orange-600 hover:to-red-600 transition-all duration-300 text-sm font-semibold shadow-md hover:shadow-lg"
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createElementVNode("i", { class: "fas fa-arrow-right mr-2" }, null, -1),
              _createTextVNode(" Configurer l'import ")
            ])),
            _: 1,
            __: [4]
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"flex items-start justify-between mb-4\" data-v-71a2c55a><div class=\"w-12 h-12 rounded-xl bg-gradient-to-br from-green-500 to-emerald-600 flex items-center justify-center text-white text-xl\" data-v-71a2c55a><i class=\"fab fa-shopify\" data-v-71a2c55a></i></div></div><h3 class=\"text-base font-semibold text-black mb-2\" data-v-71a2c55a> Import Shopify </h3><p class=\"text-sm text-black leading-relaxed mb-4 flex-1\" data-v-71a2c55a> Connectez votre boutique Shopify en un clic et consultez votre catalogue depuis eFashion. </p>", 3)),
          _createVNode(_component_router_link, {
            to: { name: 'services/shopify' },
            class: "mt-auto block w-full text-center px-6 py-2.5 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-lg hover:from-green-600 hover:to-emerald-700 transition-all duration-300 text-sm font-semibold shadow-md hover:shadow-lg"
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createElementVNode("i", { class: "fas fa-arrow-right mr-2" }, null, -1),
              _createTextVNode(" Configurer l'import ")
            ])),
            _: 1,
            __: [6]
          })
        ])
      ])
    ]),
    _createVNode(ConfirmModal, {
      show: showProductManagerCguModal.value,
      title: "Conditions d'utilisation",
      message: _unref(cguModalMessage),
      "confirm-text": "Continuer",
      "confirm-button-class": "bg-blue-600 hover:bg-blue-700 focus:ring-blue-500",
      "confirm-disabled": !productManagerCguAccepted.value || isAcceptingCgu.value,
      "max-width-class": "max-w-lg",
      onConfirm: confirmProductManagerAccess,
      onCancel: closeProductManagerCguModal
    }, {
      extra: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("p", _hoisted_9, [
            _cache[9] || (_cache[9] = _createTextVNode(" Veuillez consulter les ")),
            _createElementVNode("a", {
              href: cguUrl,
              target: "_blank",
              rel: "noopener noreferrer",
              class: "text-blue-600 font-medium hover:text-blue-800 underline",
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
            }, " Conditions d'utilisation "),
            _cache[10] || (_cache[10] = _createTextVNode(" avant de poursuivre. "))
          ]),
          _createElementVNode("label", _hoisted_10, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((productManagerCguAccepted).value = $event)),
              type: "checkbox",
              class: "mt-1 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
            }, null, 512), [
              [_vModelCheckbox, productManagerCguAccepted.value]
            ]),
            _cache[11] || (_cache[11] = _createElementVNode("span", { class: "text-sm text-black leading-relaxed" }, " J'ai lu et j'accepte les Conditions d'utilisation ", -1))
          ])
        ])
      ]),
      _: 1
    }, 8, ["show", "message", "confirm-disabled"])
  ]))
}
}

})